module.exports = __webpack_public_path__ + "media/images/application/icons/like-full-1839f008f6634b8e232f134782f90099.svg";